import React from 'react';
import LoadableIcon from './LoadableIcon';
import { Button, Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export default class ButtonDelete extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      loading: false,
      header: this.props.title || 'Warning',
      message: this.props.message || 'This cannot be undone. Are you sure?',
      useTimeout: this.props.hasOwnProperty('useTimeout') ? this.props.useTimeout : true,
    };
  }

  buttonProps() {
    let {header, message, action, noConfirm, useTimeout, ...buttonProps} = this.props;
    return buttonProps;
  }

  toggle = () => {
    if (this.props.noConfirm) {
      this.performAction();
    } else {
      this.setState({ modal: !this.state.modal });
    }
  }

  confirm = () => {
    this.toggle();
    if (this.state.useTimeout) {
      setTimeout(this.performAction, 500);
    } else {
      this.performAction();
    }
  }

  performAction = () => {
    this.setState({ loading: true });
    this.props.action();
  }

  render() {
    return (<Button
      {...this.buttonProps()}
      color={this.state.loading ? 'secondary' : 'danger'}
      onClick={this.toggle}
      key={`${this.props.id}-del-button`}
    >
      <LoadableIcon
        loading={this.state.loading}
        icon='fa-trash'
      />
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        key={`${this.props.id}-del-modal`}
        className="modal-danger"
      >
        <div className="modal-header">
          <h3 className="modal-header-title">{this.state.header}</h3>
        </div>
        <ModalBody>
          {this.state.message}
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={this.confirm}
            className="float-md-start"
          >
            Delete
          </Button>
          <Button
            color="info"
            onClick={this.toggle}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Button>);
  }
}
